<script lang="ts">
  import { Info } from "svelte-feathers"
</script>

<aside class="tip | italic p-3 bg-gray-100 border-gray-300 flex justify-start items-start" role="note">
  <Info size="20" class="text-gray-600 mr-2 shrink-0" />
  <div>
    <slot />
  </div>
</aside>

<style>
  .tip {
    border-left-width: 2px;
  }
</style>
